import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import { LockIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import { InputWrap, StyledInputPassword, ThemeLoginButton } from 'pages/login/login_style';
import LoginButtonLoader from 'component/loader_component/loginButtonLoader';
import { useDispatch } from 'react-redux';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { passwordNextLogon } from 'redux/slices/resetPassword';

export default function ChangePasswordComponent({ theme }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!localStorage.getItem('nextLogon')) {
      navigate('/');
    }
  }, [navigate]);

  const onFinish = async (values) => {
    values.userName = localStorage.getItem('dn');
    values.fqdn = localStorage.getItem('domain');
    try {
      setLoading(true);
      const sweetAlert = await dispatch(passwordNextLogon(values));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        localStorage.clear();
        const result = await Swal.fire({
          icon: 'success',
          allowOutsideClick: false,
          title: sweetAlert.payload.data,
          showConfirmButton: true,
          confirmButtonColor: 'green',
          width: '400px',
          heightAuto: false,
          confirmButtonText: 'Login',
          customClass: {
            container: 'custom-swal-container',
            icon: 'custom-swal-icon',
            title: 'custom-swal-title',
          },
        });
        if (result.isConfirmed) {
          navigate('/login');
        }
      } else if (sweetAlert.payload && sweetAlert.payload.status === 400) {
        if (sweetAlert.payload.data === 'Invalid current password') {
          SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'warning', buttonColor: 'orange' });
        } else {
          SweetSweetAlert({ text: sweetAlert.payload.data, icon: 'error', buttonColor: 'red' });
        }
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
  };
  const validatePasswordMatch = async (_, value) => {
    const newPassword = form.getFieldValue('newPassword');
    if (newPassword && value === newPassword) {
      return Promise.resolve();
    } else {
      throw new Error('Passwords do not match');
    }
  };
  return (
    <div className='change-content-component'>
      <Form onFinish={onFinish} name='change_password' scrollToFirstError form={form} className='change-form-element'>
        <InputWrap className='change-input-wrapper'>
          <Form.Item
            name='newPassword'
            rules={[{ required: true, message: 'Please enter the Password.' }]}
            className='change-form-item-newPass'
          >
            <StyledInputPassword
              className={`${theme} change-input-newPass`}
              size='large'
              prefix={<LockIcon className='icon-color' />}
              placeholder='New Password'
            />
          </Form.Item>
          <Form.Item
            name='confirmPassword'
            dependencies={['newPassword']}
            rules={[{ required: true, message: 'Please Confirm Your Password.' }, { validator: validatePasswordMatch }]}
            className='change-form-item-confirmPass'
          >
            <StyledInputPassword
              className={`${theme} change-input-confirmPass`}
              size='large'
              prefix={<LockIcon className='icon-color' />}
              placeholder='Confirm Password'
            />
          </Form.Item>

          <Form.Item className='change-form-item-submit'>
            <ThemeLoginButton className={`${theme} change-submit-button`} type='primary'>
              {loading ? <LoginButtonLoader /> : 'Change Password'}
            </ThemeLoginButton>
          </Form.Item>
        </InputWrap>
      </Form>
    </div>
  );
}
